import TermList from "../AdminTermList";

export default class AdminTermListServiceQuotePartSource extends TermList {
  /**
   * @returns {string} The term type.
   */
  getType() {
    return "service_quote_part_source";
  }
}
